export const STATUS = {
  IDLE: 'IDLE',
  PLAYING: 'PLAYING',
  LOADING: 'LOADING'
}

export const initialState = {
  updates: [],
  genesis: 0,
  terminus: 0,
  start: 0,
  idle: {
    total: 0,
    start: 0
  },
  elapsed: 0,
  loading: false,
  status: 'IDLE'
}

export function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return init(state, action.payload)
    case 'insert_updates':
      return insertUpdates(state, action.payload)
    case 'play': {
      const now = action.payload.now
      if (state.start == -1) {
        // seeked
        return {
          ...state,
          start: now - state.elapsed,
          idle: {
            start: 0,
            total: 0
          },
          loading: false,
          status: STATUS.PLAYING
        }
      }

      const idleTotal =
        state.elapsed === 0 ? 0 : now - state.idle.start + state.idle.total
      return {
        ...state,
        start: state.elapsed === 0 ? now : state.start,
        elapsed: now - state.start - idleTotal,
        idle: {
          start: 0,
          total: idleTotal
        },
        loading: false,
        status: STATUS.PLAYING
      }
    }
    case 'pause':
      return {
        ...state,
        idle: {
          ...state.idle,
          start: state.start + state.idle.total + state.elapsed
        },
        loading: !!action.payload.loading,
        status: STATUS.IDLE
      }
    case 'loading':
      return {
        ...state,
        loading: true
      }
    case 'stop':
      return {
        ...initialState,
        genesis: state.genesis,
        terminus: state.terminus,
        updates: state.updates
      }
    case 'progress':
      return {
        ...state,
        elapsed: action.payload.elapsed
      }
    case 'seek': {
      const { timestamp } = action.payload

      return {
        ...state,
        elapsed: timestamp,
        start: -1,
        idle: {
          total: 0,
          start: 0
        }
      }
    }
    default:
      return state
  }
}

function init(state, { updates }) {
  const sortedUpdates = combineUpdates([], updates)
  const genesis = Number(sortedUpdates[0]?.createdAt || 0)
  const terminus = Number(
    sortedUpdates[sortedUpdates.length - 1]?.createdAt || 0
  )
  const normalizedUpdates = normalizeUpdateTimestamps(genesis, sortedUpdates)

  return {
    ...state,
    genesis,
    terminus,
    updates: normalizedUpdates
  }
}

function insertUpdates(state, { updates }) {
  const combinedUpdates = combineUpdates(state.updates, updates)
  const normalizedUpdates = normalizeUpdateTimestamps(
    state.genesis,
    combinedUpdates
  )

  return {
    ...state,
    updates: normalizedUpdates
  }
}

function combineUpdates(currentUpdates, newUpdates) {
  return currentUpdates
    .concat(newUpdates)
    .map((update) => ({
      ...update,
      createdAt: new Date(update.createdAt)
    }))
    .sort((a, b) => a.createdAt - b.createdAt)
}

function normalizeUpdateTimestamps(genesis, updates) {
  return updates.map((update, i) => {
    const prevUpdate = updates[i - 1]
    const timestamp = prevUpdate ? update.createdAt - genesis : 0

    return {
      ...update,
      payload:
        update.payload instanceof Uint8Array
          ? update.payload
          : new Uint8Array(update.payload),
      timestamp
    }
  })
}
